// Тот же предел, что в backend/password_policy.py (с 1.5.2 — 10 знаков).
export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_HINT =
  'Минимум 10 символов, обязательно буквы и цифры';

export function validatePassword(password) {
  if (!password || password.length < PASSWORD_MIN_LENGTH) {
    return PASSWORD_HINT;
  }
  if (!/[A-Za-zА-Яа-яЁё]/.test(password)) {
    return PASSWORD_HINT;
  }
  if (!/\d/.test(password)) {
    return PASSWORD_HINT;
  }
  return null;
}
